const STORAGE_PREFIX = "ask-puntt.review-preflight:";

export type ReviewPreflightPersistedState = {
  selectedIds: string[];
  submitted: boolean;
};

export function reviewPreflightStorageKey(messageId: string): string {
  return `${STORAGE_PREFIX}${messageId}`;
}

export function readReviewPreflightState(
  messageId: string,
): ReviewPreflightPersistedState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(
      reviewPreflightStorageKey(messageId),
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (parsed == null || typeof parsed !== "object") return null;
    const row = parsed as Record<string, unknown>;
    const selectedIds = row.selectedIds;
    const submitted = row.submitted;
    if (!Array.isArray(selectedIds)) return null;
    if (typeof submitted !== "boolean") return null;
    return {
      selectedIds: selectedIds.filter(
        (id): id is string => typeof id === "string",
      ),
      submitted,
    };
  } catch {
    return null;
  }
}

export function writeReviewPreflightState(
  messageId: string,
  state: ReviewPreflightPersistedState,
): void {
  if (typeof window === "undefined") return;
  // why: the read path above is guarded but this write was not. setItem
  // THROWS (QuotaExceededError / SecurityError) when storage is full or
  // blocked, and callers run it from a React state updater, so an uncaught
  // throw crashes the chat tree instead of only losing the preflight state.
  try {
    window.localStorage.setItem(
      reviewPreflightStorageKey(messageId),
      JSON.stringify(state),
    );
  } catch {
    // ignore — preflight persistence is best-effort
  }
}
